import { grScope } from "@gr-common/body/logger";
import type { ApmRum } from "@gr-exports/body/apm";
import { AsyncNamespace } from "../nexus/namespace/namespace.types";

declare global {
  interface NexusInterfaces {
    /**
 *
 *
 */
    debug: AsyncNamespace<{
      /*                      */
      sendLog: ApmRum["sendCustomError"];
    }>;
  }
}

const log = grScope.scope("legacy.debug");

/*                                                   */
otto.debug.assignNamespace(
  {
    sendLog: (namespace, data) => {
      log.warn("sendLog is deprecated, use apm.sendCustomError instead");
      return otto.apm.sendCustomError(namespace, data);
    },
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);
